module.exports = __webpack_public_path__ + "img/order-status-panel.0fd7c8ac.webp";